module.exports = __webpack_public_path__ + "fonts/u2f_ico@2x.2c816ef6fb7dc6a45144119bae854d17.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/u2f_ico@2x.png
// module id = 796
// module chunks = 9